import { action } from 'easy-peasy';
import { IActionRemoveCarePlanMedication } from '../types';

const removeCarePlanMedication: IActionRemoveCarePlanMedication = action((state, id) => {
  state.items = state.items.filter(item => item.id !== id);
});

export default removeCarePlanMedication;
